import {animate, state, style, transition, trigger} from '@angular/animations';

export const slide = trigger(
  'slide', [state('void', style({height: 0, overflow: 'hidden'})), state('*', style({height: '*', overflow: 'unset'})), transition('* => *', animate(250))]);

export const fade = trigger('fade', [
  transition(':enter', [style({opacity: 0}), animate('250ms', style({opacity: 1}))]),
  transition(':leave', [style({opacity: 1}), animate('250ms', style({opacity: 0}))])
]);
